import { AxiosResponseHeaders } from 'axios';
import { OTPAuthorizationPhoneResponseDTO } from '../entities';

const otpAuthorizationPhoneDTOToOTPAuthorizationPhoneAdapter = (
  data: OTPAuthorizationPhoneResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { otpAuthorizationPhoneDTOToOTPAuthorizationPhoneAdapter };
